import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "m-ticketType" }
const _hoisted_2 = { class: "m-ticketType__data" }
const _hoisted_3 = { class: "m-ticketType__heading" }
const _hoisted_4 = { class: "m-ticketType__price" }
const _hoisted_5 = {
  "data-qa": 'ticket-type-price',
  class: "m-ticketType__pricePrimary"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "m-ticketType__priceSecondary"
}
const _hoisted_8 = {
  key: 0,
  class: "m-ticketType__additional"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stepper_component = _resolveComponent("stepper-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.data.text), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.CurrencyHandler.displayPrimaryCurrency(_ctx.data.price ? _ctx.data.price : 0)) + " ", 1),
          _hoisted_6
        ]),
        (_ctx.CurrencyHandler.isSecondaryCurrencyDisplayed)
          ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.CurrencyHandler.displaySecondaryCurrency(_ctx.data.price ? _ctx.data.price : 0)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_stepper_component, {
      state: _ctx.stepperState,
      onStateChange: _ctx.handleStepperStateChange
    }, null, 8, ["state", "onStateChange"]),
    (_ctx.data.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, "* " + _toDisplayString(_ctx.data.description), 1))
      : _createCommentVNode("", true)
  ]))
}